//import { LazyLoadImageModule } from 'ng-lazyload-image';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { APP_BOOTSTRAP_LISTENER, APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
import { NgxStripeModule } from 'ngx-stripe';
import { environment } from 'src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SentryErrorHandler } from './providers/sentry.provider';
import { LayoutModule } from './shared/layout/layout.module';
import { OverlayModule } from '@angular/cdk/overlay';
import { VlWindowModule } from 'vl-tailwind-layout';
import { SocketIOService } from './services/socketio/socketio.service';
import { FileMediaService } from './services/file-media/file-media.service';
import { VlApiService } from './services/vl-api/vl-api.service';
import { ToastrModule } from 'ngx-toastr';
import { ToastrModule as CToastrModule } from './shared/components/toastr/toastr.module';
import { ToastrComponent } from './shared/components/toastr/toastr.component';
import { KeycloakInitializerService } from './services/keycloakInitializer.service';
import { AcceptLanguageInterceptor } from './providers/accept-language.interceptor';

export function keycloakInitializerFactory(service: KeycloakInitializerService): () => Promise<boolean> {
    return () => service.initializeKeycloak();
}

@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        CToastrModule,
        FormsModule,
        BrowserAnimationsModule,
        HttpClientModule,
        KeycloakAngularModule,
        LayoutModule,
        NgxStripeModule.forRoot(environment.stripeApiKey),  // TODO: stripe account
        OverlayModule,
        VlWindowModule,
        ToastrModule.forRoot({
            toastComponent: ToastrComponent,
            timeOut: 3000,
            maxOpened: 4,
            autoDismiss: true,
            preventDuplicates: false,
            countDuplicates: false,
            progressBar: false,
            toastClass: 'custom',
            positionClass: 'toast-top-center',
            tapToDismiss: false,
            closeButton: true
        })
    ],
    providers: [
        SocketIOService,
        FileMediaService,
        VlApiService,
        KeycloakInitializerService,
        {
            provide: APP_BOOTSTRAP_LISTENER,
            useFactory: keycloakInitializerFactory,
            deps: [KeycloakInitializerService],
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AcceptLanguageInterceptor,
            multi: true
        },
        /*{
            provide: APP_LISTENER,
            useFactory: initializer,
            multi: true,
            deps: [KeycloakService]
        },*/
        {
            provide: ErrorHandler,
            useClass: SentryErrorHandler,
        },
    ],
    bootstrap: [AppComponent],
})
export class AppModule {
    constructor() {

    }
}